export const appBasePath = process.env.NEXT_PUBLIC_BASE_PATH || ''

export function withBasePath(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${appBasePath}${normalizedPath}`
}
